/** @jsx jsx */
import { jsx } from '@emotion/core'
import { HeadingSection } from 'bold-ui'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { AvaliacaoDesenvolvimentoModel } from '../model'
import { MarcoFormSectionAccordion } from './MarcoFormSectionAccordion'
import { reflexosNeuroOptions } from './reflexosNeuroList'

export interface MarcosDesenvolvimentoModel {
  marcoDesenvolvimento: AvaliacaoDesenvolvimentoModel[]
}

interface MarcosDesenvolvimentoViewProps {
  name: MetaPath<MarcosDesenvolvimentoModel>
  prontuarioId: ID
}

export default function MarcosDesenvolvimentoView(props: MarcosDesenvolvimentoViewProps) {
  const { name } = props

  // TODO foundation - esperando do load
  const {
    input: { value, onChange },
  } = useField<MarcosDesenvolvimentoModel>(name.absolutePath())
  !value && onChange(reflexosNeuroOptions)

  return (
    <HeadingSection level={4} title='Marcos de desenvolvimento'>
      <MarcoFormSectionAccordion name={name.marcoDesenvolvimento} />
    </HeadingSection>
  )
}
